import React from "react";
import { Carousel } from "antd";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";

const getSliderImage = (imagePath) => {
  return imagePath;
};

const getHeroImage = (imagePath) => {
  return imagePath;
};


const HeroSlider = ({ sliders, heroes, isDarkMode }) => {
  if ((!sliders || sliders.length === 0) && (!heroes || heroes.length === 0)) return null;

  // Custom arrows for carousel
  const SamplePrevArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        onClick={onClick}
        className="absolute z-10 flex items-center justify-center w-8 h-8 transition-opacity -translate-y-1/2 rounded-full shadow-lg opacity-0 left-4 top-1/2 md:w-10 md:h-10 bg-white/80 hover:bg-white group-hover:opacity-100"
      >
        <FiChevronLeft className="text-xl text-gray-800 md:text-2xl" />
      </button>
    );
  };

  const SampleNextArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        onClick={onClick}
        className="absolute z-10 flex items-center justify-center w-8 h-8 transition-opacity -translate-y-1/2 rounded-full shadow-lg opacity-0 right-4 top-1/2 md:w-10 md:h-10 bg-white/80 hover:bg-white group-hover:opacity-100"
      >
        <FiChevronRight className="text-xl text-gray-800 md:text-2xl" />
      </button>
    );
  };

  return (
    <div className="relative mb-0 md:mb-8  md:w-auto w-[90%] mx-auto">
      {/* Mobile View - Stack vertically (NO CHANGES) */}
      <div className="block md:hidden">
        {/* Slider Carousel */}
        {sliders && sliders.length > 0 && (
          <div className="mb-2">
            <Carousel
              autoplay
              autoplaySpeed={5000}
              dots={{ className: "custom-dots" }}
              arrows
              prevArrow={<SamplePrevArrow />}
              nextArrow={<SampleNextArrow />}
            >
              {sliders.map((slider) => (
                <div
                  key={slider.id}
                  className="relative h-[150px] rounded-xl overflow-hidden"
                >
                  <img
                    src={getSliderImage(slider.image)}
                    alt={slider.title || "Slider image"}
                    className="object-cover w-full h-full"
                  />
                  <div className="absolute inset-0 flex items-center bg-gradient-to-r from-black/70 via-black/30 to-transparent">
                    <div className="max-w-2xl p-4 text-white">
                      {slider.title && (
                        <h2 className="mb-1 text-lg font-bold drop-shadow-lg line-clamp-1">
                          {slider.title}
                        </h2>
                      )}
                      {slider.description && (
                        <p className="mb-2 text-xs opacity-90 drop-shadow line-clamp-1">
                          {slider.description}
                        </p>
                      )}
                      {slider.btn_text && slider.btn_url && (
                        <Link
                          to={slider.btn_url}
                          className="inline-block px-3 py-1 text-xs font-semibold transition-all transform rounded-lg bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 hover:scale-105"
                        >
                          {slider.btn_text}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        )}

        {/* Heroes Stacked Vertically */}
        {heroes && heroes.length > 0 && (
          <div className="hidden space-y-2">
            {heroes.map((hero) => (
              <Link
                key={hero.id}
                to={hero.link}
                target="_blank"
                className="block h-[140px] rounded-lg overflow-hidden"
              >
                <img
                  src={getHeroImage(hero.image)}
                  alt="Hero"
                  className="object-cover w-full h-full"
                />
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* Desktop View - Slider left, Heroes right (DECREASED HEIGHT) */}
      <div className="hidden gap-4 md:grid md:grid-cols-3">
        {/* Slider Carousel - Decreased height */}
        {sliders && sliders.length > 0 && (
          <div className="col-span-3">
            <Carousel
              autoplay
              autoplaySpeed={5000}
              dots={{ className: "custom-dots" }}
              arrows
              prevArrow={<SamplePrevArrow />}
              nextArrow={<SampleNextArrow />}
            >
              {sliders.map((slider) => (
                <div
                  key={slider.id}
                  className="relative h-[350px] rounded-xl overflow-hidden"
                >
                  <img
                    src={getSliderImage(slider.image)}
                    alt={slider.title || "Slider image"}
                    className="object-cover w-full h-full"
                  />
                  <div className="absolute inset-0 flex items-center bg-gradient-to-r from-black/70 via-black/30 to-transparent">
                    <div className="max-w-2xl p-8 text-white md:p-12">
                      {slider.title && (
                        <h2 className="mb-2 text-2xl font-bold md:text-3xl drop-shadow-lg">
                          {slider.title}
                        </h2>
                      )}
                      {slider.description && (
                        <p className="mb-4 text-sm md:text-base opacity-90 drop-shadow">
                          {slider.description}
                        </p>
                      )}
                      {slider.btn_text && slider.btn_url && (
                        <Link
                          to={slider.btn_url}
                          className="inline-block px-5 py-2 text-sm font-semibold transition-all transform bg-green-600 rounded-lg shadow-lg hover:bg-green-700 hover:scale-105"
                        >
                          {slider.btn_text}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        )}

        {/* Heroes Stacked Vertically - Adjusted height proportionally */}
        {/* {heroes && heroes.length > 0 && (
          <div className="flex flex-col col-span-2 gap-2 ">
            {heroes.map((hero) => (
              <Link
                key={hero.id}
                to={hero.link}
                target="_blank"
                className="block h-[180px] rounded-lg overflow-hidden"
              >
                <img
                  src={getHeroImage(hero.image)}
                  alt="Hero"
                  className="object-cover w-full h-full"
                />
              </Link>
            ))}
          </div>
        )} */}
      </div>

      <style jsx>{`
        :global(.custom-dots) {
          bottom: 10px;
        }
        :global(.custom-dots li button) {
          background: white !important;
          opacity: 0.5;
          width: 6px;
          height: 6px;
          border-radius: 50%;
        }
        :global(.custom-dots li.slick-active button) {
          opacity: 1;
          background: #22c55e !important;
          width: 18px;
          border-radius: 9px;
        }
      `}</style>
    </div>
  );
};

export default HeroSlider;